import * as React from 'react';
import {SchemaNavigator} from './schema-navigator/SchemaNavigator';

import {useRqlBrowser, RqlBrowserProps} from './useRqlBrowser';

import './css/rqlbrowser.css';
import {
    RqlBrowserQuerier,
    RqlBrowserControlPanel,
    RqlBrowserError,
} from './RqlBrowserComponents';

export const RqlBrowser: React.FC<RqlBrowserProps> = ({
    schemaProvider,
    clientRql,
    readonly,
}) => {
    const {
        autoHelp,
        setAutoHelp,
        showMetamodel,
        setMetamodel,
        entityTypeTextSearch,
        setEntityTypeTextSearch,
        relationsAndAttributesTextSearch,
        setRelationsAndAttributesTextSearch,
        linkedEntityTypeTextSearch,
        setLinkedEntityTypeTextSearch,
        error,
        setError,
        query,
        setQuery,
        executeQuery,
        resultsAndVariables,
        queryIsLoading,
        setCursorToken,
        isForbiddenQuery,
    } = useRqlBrowser({schemaProvider, clientRql, readonly});

    if (error !== null) {
        console.error(error);
        return <RqlBrowserError />;
    }

    return (
        <div className="rql-browser">
            {schemaProvider && (
                <div className="schema-navigator-super-container">
                    <RqlBrowserControlPanel
                        {...{
                            showMetamodel,
                            setMetamodel,
                            autoHelp,
                            setAutoHelp,
                            setEntityTypeTextSearch,
                            setRelationsAndAttributesTextSearch,
                            setLinkedEntityTypeTextSearch,
                        }}
                    />
                    <SchemaNavigator
                        {...{
                            schemaProvider,
                            showMetamodel,
                            clientRql,
                            entityTypeTextSearch,
                            setEntityTypeTextSearch,
                            relationsAndAttributesTextSearch,
                            setRelationsAndAttributesTextSearch,
                            linkedEntityTypeTextSearch,
                            setLinkedEntityTypeTextSearch,
                            handleError: setError,
                        }}
                    />
                </div>
            )}
            <RqlBrowserQuerier
                {...{
                    query,
                    setQuery,
                    executeQuery,
                    resultsAndVariables,
                    queryIsLoading,
                    setCursorToken,
                    isForbiddenQuery,
                }}
            />
        </div>
    );
};
